import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { IWorkflowCollectionState } from '../../../../workflow/store/workflow.reducer';
import { ParticleService } from '@core/services/particle.service';
import { Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { getWorkflowReducerState, isWorkflowCleanedUp } from '../../../../workflow/store/workflow.selector';
import { takeUntil } from 'rxjs/operators';
import { Configuration } from '@shared/models/configuration';
import { CreateWorkflowAction } from '../../../../workflow/store/workflow.actions';
import {getCurrentProject, ProjectState} from "../../../../projects/store/reducers/projects.reducer";
import {ProjectModel} from "../../../../projects/models/projects.models";
import {SecurityState} from "@shared/store/reducers/security.reducer";
import {getCurrentBasket} from "@shared/store/reducers/particle.reduer";
import {BasketModel} from "@shared/models/common.models";


@Component({
    standalone: false,
    selector: 'particle-participants-entity-manager-import',
  templateUrl: './participants-entity-manager-import.component.html',
  styleUrls: ['./participants-entity-manager-import.component.scss']
})
export class ParticipantsEntityManagerImportComponent implements OnInit {

  workflowTemplate: string;
  apiEndpointKey: string;
  workflowState$: any;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  hasWorkflowId = false;
  workflowId: string;
  reRouteUrl: string;
  workFlowName:string;
  currentProjectId: string;
  currentBasket: BasketModel;
  currentImportExcelName: string;
  constructor(private store: Store<IWorkflowCollectionState>,
              private particleService: ParticleService,
              private projectStore: Store<ProjectState>,
              private router: Router,
              private securitystore: Store<SecurityState>
  ) {
    this.workflowId = Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
   this.init();
  }
  init(){
    if(this.router.url.toLowerCase().includes('relevant-taxpayers')){
      this.workflowTemplate = 'import-relevant-taxpayers-workflow';
      this.currentImportExcelName = 'RelevantTaxpayers'
      this.reRouteUrl = 'dac6-reporter/participants/relevant-taxpayers';
      this.workFlowName = 'Import Relevant Taxpayers';
    }
    else if(this.router.url.toLowerCase().includes('intermediaries')){
      this.workflowTemplate = 'import-intermediaries-workflow';
      this.currentImportExcelName = 'Intermediaries'
      this.reRouteUrl = 'dac6-reporter/participants/intermediaries';
      this.workFlowName = 'Import Intermediaries';
    }
    else if(this.router.url.toLowerCase().includes('other-persons')){
      this.workflowTemplate = 'import-other-persons-workflow';
      this.currentImportExcelName = 'OtherPersons'
      this.reRouteUrl = 'dac6-reporter/participants/other-persons';
      this.workFlowName = 'Import Other Persons';
    }
  }
  ngOnInit() {
    this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state) {
        console.log('workflow', state);
        this.cleanWorkflow();
      }

    });

    this.projectStore.pipe(select(getCurrentProject), takeUntil(this.unsubscribe$)).subscribe( (project: ProjectModel) => {
      if (project) {
        this.currentProjectId = project.ProjectId;
        this.createWorkflow();
      }
    });
  }

  private createWorkflow() {
    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId , this.workFlowName, this.workflowTemplate);
    this.securitystore.select(getCurrentBasket).subscribe(p => {
      this.currentBasket = p;
    });
    action.setParameters({
      'PROJECT_ID': this.currentProjectId,
      'ImportSampleExcelTemplateName': this.getImportSampleExcelTemplateName(),
      'TOOL_NAME' : this.getToolName()
    });
    this.store.dispatch(action);
  }

  getToolName() {
    const basketId = this.currentBasket.id;
    switch (this.currentImportExcelName) {
      case 'RelevantTaxpayers':
        return basketId === 'dac6-mx' ? 'Taxpayers' : ' Relevant Taxpayers';
      case 'Intermediaries':
        return basketId === 'dac6-mx' ? 'Tax Advisors' : 'Intermediaries';
      case 'OtherPersons':
        return 'Other Persons';
    }
    return '';
  }

  getImportSampleExcelTemplateName() {
    const basketCountry = this.currentBasket.id.split('-')[1];
    const excelName = this.currentImportExcelName + 'ImportSampleExcelTemplate-' + basketCountry + '.xlsx';
    return excelName;
  }

  cleanWorkflow() {
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.router.navigateByUrl(this.reRouteUrl);
      }
    });
  }
  onGridCellValueChange($event) {
    console.log('cell value change', $event);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


}
